import { useEffect, useState } from "react"
import { Button } from "./ui"

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<{ outcome: "accepted" | "dismissed" }>
}

export function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null)
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("admin_install_prompt_dismissed") === "1",
  )

  useEffect(() => {
    function handlePrompt(event: Event) {
      event.preventDefault()
      setDeferredPrompt(event as BeforeInstallPromptEvent)
    }

    window.addEventListener("beforeinstallprompt", handlePrompt)
    return () => window.removeEventListener("beforeinstallprompt", handlePrompt)
  }, [])

  if (!deferredPrompt || dismissed) return null

  async function handleInstall() {
    if (!deferredPrompt) return

    const result = await deferredPrompt.prompt()
    if (result.outcome === "accepted") {
      setDeferredPrompt(null)
    }
  }

  function handleDismiss() {
    sessionStorage.setItem("admin_install_prompt_dismissed", "1")
    setDismissed(true)
    setDeferredPrompt(null)
  }

  return (
    <div className="admin-pwa-banner" role="status">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-500">
          Install App
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-900">
          Install LoanCore Admin for a full-screen, app-like workflow.
        </p>
        <p className="mt-1 text-sm text-slate-500">
          Use the installed app for quicker launch, cleaner multitasking, and safer field access on tablets.
        </p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button type="button" className="w-full sm:w-auto" onClick={() => void handleInstall()}>
          Install
        </Button>
        <Button type="button" variant="ghost" className="w-full sm:w-auto" onClick={handleDismiss}>
          Not now
        </Button>
      </div>
    </div>
  )
}
